import React, { useEffect } from 'react'
import { FormProvider, useForm, useWatch } from 'react-hook-form'

import { Box, Button, Flex, Heading, VStack } from '@chakra-ui/react'

import { Checkbox, Input, PriceInput, Select } from '@/components/Form'

const RuleForm = ({ rule, onSubmitAction }) => {
  const methods = useForm({ defaultValues: rule })

  console.log('rule', rule)

  const ruleType = useWatch({ name: 'type', control: methods.control })
  const hasUpperLimit = useWatch({ name: 'hasUpperLimit', control: methods.control })
  const hasLowerLimit = useWatch({ name: 'hasLowerLimit', control: methods.control })

  useEffect(() => {
    methods.reset(rule)
  }, [rule, methods])

  const onSubmit = async (data) => {
    Object.keys(data).forEach((key) => {
      if (data[key] === '') {
        delete data[key]
      }
    })

    // console.log('upperLimit', { upperLimit: data?.upperLimit });
    onSubmitAction(data)
  }

  return (
    <Box shadow="md" borderWidth="1px" bg="white" w="100%" mb="auto">
      <FormProvider {...methods}>
        <form onSubmit={methods.handleSubmit(onSubmit)}>
          <Flex p={5} borderBottom="1px solid #d8dbe0">
            <Heading> Rule Information </Heading>
          </Flex>
          <Box p={5}>
            <VStack>
              <Input name="name" label="Rule Name" type="text" placeholder="Enter value" isRow />
              <Select
                name="offerType"
                label="Offer Type"
                options={[
                  { value: 'maintenance', label: 'Maintenance' },
                  { value: 'project', label: 'Project' },
                  { value: 'all', label: 'All' },
                ]}
                isRow
              />
              <Select
                name="type"
                label="Rule Type"
                options={[
                  { value: 'grossMargin', label: 'Gross Margin' },
                  { value: 'price', label: 'Price' },
                  { value: 'annualPrice', label: 'Annual Price' },
                  { value: 'liability', label: 'Liability' },
                  { value: 'vo', label: 'VO' },
                ]}
                isRow
              />

              {ruleType === 'liability' && (
                <>
                  <Checkbox name="withinContractValue" label="Within Contract Value" isRow />
                </>
              )}
              <Select
                name="isSiemensStandardTerms"
                label="Is Siemens Standard Condition"
                defaultValues={'all'}
                options={[
                  { value: 'all', label: 'All' },
                  { value: 'no', label: 'No' },
                  { value: 'yes', label: 'Yes' },
                ]}
                isRow
              />
              <Select
                name="isHighRisk"
                label="Is High Risk"
                defaultValues={'all'}
                options={[
                  { value: 'all', label: 'All' },
                  { value: 'no', label: 'No' },
                  { value: 'yes', label: 'Yes' },
                ]}
                isRow
              />

              <Checkbox name="hasUpperLimit" label="Has Upper Limit" isRow />
              {hasUpperLimit && <PriceInput name="upperLimit" label="Upper Limit" placeholder="Enter value" isRow />}
              <Checkbox name="hasLowerLimit" label="Has Lower Limit" isRow />
              {hasLowerLimit && <PriceInput name="lowerLimit" label="Lower Limit" placeholder="Enter value" isRow />}

              <Checkbox name="requiredBoth" label="Required Both" isRow />
              <Select
                name="currency"
                label="Currency"
                options={[
                  { value: 'HKD', label: 'HKD' },
                  { value: 'EUR', label: 'EUR' },
                ]}
                isRow
              />
              <PriceInput
                name="contractThreshold"
                label="Contract Threshold"
                placeholder="Enter value"
                isRow
                isRequired={false}
              />

              <Select
                name="technicalApproverLevel"
                label="Technical Approver Level"
                options={[
                  { value: 0, label: 0 },
                  { value: 1, label: 1 },
                  { value: 2, label: 2 },
                  { value: 3, label: 3 },
                ]}
                isRow
              />
              <Select
                name="commercialApproverLevel"
                label="Commercial Approver Level"
                options={[
                  { value: 0, label: 0 },
                  { value: 1, label: 1 },
                  { value: 2, label: 2 },
                  { value: 3, label: 3 },
                ]}
                isRow
              />
              <Checkbox name="isDeleted" label="Deleted" isRow />
            </VStack>

            <Button mt="6" colorScheme="blue" type="submit">
              Save
            </Button>
          </Box>
        </form>
      </FormProvider>
    </Box>
  )
}

export default RuleForm
